import { useQuery } from "urql";

import {
  ClikGrantedBondFilter,
  ClikGrantedBondOrderBy,
  GetClikGrantedBondsDocument,
} from "../../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../../utils/api.ts";
import { ApiHookProps } from "../../types.ts";

export const useClikGrantedBonds = ({
  filter,
  orderBy,
  page,
}: ApiHookProps<ClikGrantedBondFilter, ClikGrantedBondOrderBy>) => {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
  };
  return useQuery({ query: GetClikGrantedBondsDocument, variables });
};
